module.exports = {"371083001":"城区街道","371083100":"夏村镇","371083101":"乳山口镇","371083102":"海阳所镇","371083103":"白沙滩镇","371083104":"大孤山镇","371083105":"南黄镇","371083106":"冯家镇","371083107":"下初镇","371083108":"午极镇","371083109":"育黎镇","371083110":"崖子镇","371083111":"诸往镇","371083112":"乳山寨镇","371083114":"徐家镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371083.json
// module id = 1334
// module chunks = 0